import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import VideoPlay from './VideoPlay';
import Modal from './Modal';

const Advice = ({
  advice = undefined,
  onAccept = () => {},
}) => {
  if (!advice) return null;
  const texts = advice.split(/\[.+?\]/gi);
  const videos = (advice.match(/\[.+?\]/g) || []).map((w) => w.slice(1, -1));

  return (
    <ModalStyled>
      <Container>
        <Content>
          {texts.map((text, index) => (
            <React.Fragment key={index}>
              {text}
              {videos[index] && <VideoPlayStyled url={videos[index]} />}
            </React.Fragment>
          ))}
        </Content>
        <ButtonStyled primary text='Aceptar' onClick={() => onAccept()} />
      </Container>
    </ModalStyled>
  );
};


const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Content = styled.div`
  font-size: 0.9em;
  white-space: pre-wrap;
  width: 100%;
  overflow-y: auto;
`;

const VideoPlayStyled = styled(VideoPlay)`
  margin: 10px 0px;
`;

const ModalStyled = styled(Modal)`
  display: flex;
  padding: 20px;
  max-width: 280px;
  width: 100%;
`;

const ButtonStyled = styled(Button)`
  margin: 15px 0px 0px 0px;
`;

export default Advice;
